import { Component, Input } from '@angular/core';

import { TranslatePipe } from '../../../core/i18n/translate.pipe';

@Component({
  selector: 'app-page-header',
  standalone: true,
  imports: [TranslatePipe],
  template: `
    <div class="page-header">
      <div>
        <h1 class="page-header__title">{{ title | t }}</h1>

        @if (subtitle) {
          <div class="page-header__subtitle">{{ subtitle | t }}</div>
        }
      </div>
    </div>
  `,
  styles: [`
    .page-header {
      margin-bottom: 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 16px;
    }

    .page-header__title {
      margin: 0;
      font-size: 28px;
      color: #111827;
    }

    .page-header__subtitle {
      margin-top: 6px;
      color: #6b7280;
      font-size: 14px;
    }
  `]
})
export class PageHeaderComponent
{
  @Input()
  public title = '';

  @Input()
  public subtitle: string | null = null;
}
